"use client";

import { ComponentProps } from "react";
import { useGlitch } from "react-powerglitch";

export const GlitchyText = ({ ref, ...props }: ComponentProps<"span">) => {
  const glitch = useGlitch({ timing: { duration: 4000 } });
  // const glitch = useGlitch({ timing: { duration: 4000, easing: "ease-in" } });

  return <span ref={ref ? ref : glitch.ref} {...props} />;
};
